import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import '../../index.css'

export default function BasicMenu({ btnDescription }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        if (anchorEl) {
            return handleClose()
        }
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <IconButton
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <MenuIcon fontSize='large' />
            </IconButton>
            <Menu
                id="menu-action"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {btnDescription.map((btn, index) => (
                    <MenuItem
                        key={index}
                        onClick={() => {
                            const section = document.getElementById(btn.id);
                            window.scrollTo({
                                top: section?.offsetTop,
                                behavior: 'smooth'
                            });
                            setAnchorEl(null);
                        }}
                    >
                        {btn.name}
                    </MenuItem>
                ))}

            </Menu>
        </div>
    );
}